import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeftIcon } from 'lucide-react';
export function TermsAndConditions() {
  return <div className="min-h-screen bg-[#f4f7f9] font-sans text-slate-800" data-id="element-775">
      {/* Header Section */}
      <header className="bg-[#0f2546] text-white pt-8 pb-8 px-6 md:px-12" data-id="element-776">
        <div className="max-w-4xl mx-auto flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4" data-id="element-777">
          <Link to="/" className="flex items-center space-x-2" data-id="element-778">
            <span className="text-2xl font-bold tracking-tight" data-id="element-779">
              Swedenmark <span className="text-blue-400" data-id="element-780">AI</span>
            </span>
          </Link>
          <Link to="/" className="text-slate-300 hover:text-white flex items-center gap-2 text-sm transition-colors font-medium" data-id="element-781">
            <ArrowLeftIcon size={16} data-id="element-782" />
            Back to Home
          </Link>
        </div>
      </header>

      {/* Content Section */}
      <main className="max-w-4xl mx-auto px-6 md:px-12 py-12" data-id="element-783">
        <div className="bg-white p-8 md:p-12 rounded-2xl shadow-sm border border-slate-200" data-id="element-784">
          <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-2" data-id="element-785">
            Terms & Conditions
          </h1>
          <p className="text-slate-500 mb-10 font-medium" data-id="element-786">
            Effective Date: March 18, 2026
          </p>

          <div className="space-y-8 text-slate-700 leading-relaxed" data-id="element-787">
            <section data-id="element-788">
              <h2 className="text-xl font-bold text-gray-900 mb-3" data-id="element-789">
                1. Acceptance of Terms
              </h2>
              <p data-id="element-790">
                By accessing and using the website swedenmark.ai (the "Site")
                and the services provided by Swedenmark AI ("we," "our," or
                "us"), you agree to be bound by these Terms & Conditions. If you
                do not agree with any part of these terms, you must not use our
                Site or services.
              </p>
            </section>

            <section data-id="element-791">
              <h2 className="text-xl font-bold text-gray-900 mb-3" data-id="element-792">
                2. Description of Services
              </h2>
              <p data-id="element-793">
                Swedenmark AI provides AI automation and growth consulting
                services, including but not limited to lead generation systems,
                automated outreach, and business process automation. The
                information provided on the Site is for general informational
                purposes and to demonstrate our capabilities.
              </p>
            </section>

            <section data-id="element-794">
              <h2 className="text-xl font-bold text-gray-900 mb-3" data-id="element-795">
                3. Live Demo & Communications Consent
              </h2>
              <p className="mb-3" data-id="element-796">
                Our Site features a "Live Demo" designed to showcase our
                automated outreach capabilities. By submitting your information
                (including your name, email, company, and phone number) through
                the Live Demo form, you expressly consent to:
              </p>
              <ul className="list-disc pl-5 space-y-1 mb-3" data-id="element-797">
                <li data-id="element-798">
                  Receive automated, personalized emails from Swedenmark AI.
                </li>
                <li data-id="element-799">
                  Receive automated text messages (SMS) from Swedenmark AI to
                  the phone number provided.
                </li>
              </ul>
              <p data-id="element-800">
                Message and data rates may apply. You may opt out of SMS
                communications at any time by replying "STOP" to any message.
                You may opt out of email communications by clicking the
                "unsubscribe" link in the emails. For more information on how we
                handle your data, please review our Privacy Policy.
              </p>
            </section>

            <section data-id="element-801">
              <h2 className="text-xl font-bold text-gray-900 mb-3" data-id="element-802">
                4. User Responsibilities
              </h2>
              <p data-id="element-803">
                When using our Site or submitting forms, you agree to provide
                accurate, current, and complete information. You agree not to
                use the Site for any unlawful purpose or in any way that could
                damage, disable, overburden, or impair our servers or networks.
                You are solely responsible for the content of any messages or
                information you submit through our forms.
              </p>
            </section>

            <section data-id="element-804">
              <h2 className="text-xl font-bold text-gray-900 mb-3" data-id="element-805">
                5. Intellectual Property
              </h2>
              <p data-id="element-806">
                All content, features, and functionality on the Site—including
                text, graphics, logos, icons, and software—are the exclusive
                property of Swedenmark AI and are protected by United States and
                international copyright, trademark, and other intellectual
                property laws. You may not reproduce, distribute, modify, or
                create derivative works of any material from our Site without
                our express written consent.
              </p>
            </section>

            <section data-id="element-807">
              <h2 className="text-xl font-bold text-gray-900 mb-3" data-id="element-808">
                6. Disclaimer of Warranties
              </h2>
              <p data-id="element-809">
                The Site and our services are provided on an "AS IS" and "AS
                AVAILABLE" basis. Swedenmark AI makes no representations or
                warranties of any kind, express or implied, regarding the
                operation of the Site, the accuracy of the information, or the
                results that may be obtained from the use of our services. We
                disclaim all warranties, including implied warranties of
                merchantability and fitness for a particular purpose.
              </p>
            </section>

            <section data-id="element-810">
              <h2 className="text-xl font-bold text-gray-900 mb-3" data-id="element-811">
                7. Limitation of Liability
              </h2>
              <p data-id="element-812">
                To the fullest extent permitted by applicable law, Swedenmark AI
                shall not be liable for any indirect, incidental, special,
                consequential, or punitive damages, including loss of profits,
                data, or business opportunities, arising out of or related to
                your use of the Site or our services, even if we have been
                advised of the possibility of such damages.
              </p>
            </section>

            <section data-id="element-813">
              <h2 className="text-xl font-bold text-gray-900 mb-3" data-id="element-814">
                8. Indemnification
              </h2>
              <p data-id="element-815">
                You agree to indemnify, defend, and hold harmless Swedenmark AI,
                its officers, directors, employees, and agents from and against
                any claims, liabilities, damages, judgments, awards, losses,
                costs, or expenses (including reasonable attorneys' fees)
                arising out of or relating to your violation of these Terms &
                Conditions or your use of the Site.
              </p>
            </section>

            <section data-id="element-816">
              <h2 className="text-xl font-bold text-gray-900 mb-3" data-id="element-817">
                9. Governing Law
              </h2>
              <p data-id="element-818">
                These Terms & Conditions and your use of the Site shall be
                governed by and construed in accordance with the laws of the
                State of Florida, without regard to its conflict of law
                principles. Any legal action or proceeding related to these
                terms shall be brought exclusively in the state or federal
                courts located in Florida.
              </p>
            </section>

            <section data-id="element-819">
              <h2 className="text-xl font-bold text-gray-900 mb-3" data-id="element-820">
                10. Termination
              </h2>
              <p data-id="element-821">
                We reserve the right, in our sole discretion, to terminate or
                suspend your access to all or part of the Site, for any reason,
                including without limitation, breach of these Terms &
                Conditions.
              </p>
            </section>

            <section data-id="element-822">
              <h2 className="text-xl font-bold text-gray-900 mb-3" data-id="element-823">
                11. Changes to Terms
              </h2>
              <p data-id="element-824">
                We may revise and update these Terms & Conditions from time to
                time in our sole discretion. All changes are effective
                immediately when we post them. Your continued use of the Site
                following the posting of revised Terms & Conditions means that
                you accept and agree to the changes.
              </p>
            </section>

            <section data-id="element-825">
              <h2 className="text-xl font-bold text-gray-900 mb-3" data-id="element-826">
                12. Contact Us
              </h2>
              <p data-id="element-827">
                If you have any questions about these Terms & Conditions, please
                contact us at:
              </p>
              <address className="mt-2 not-italic text-slate-600" data-id="element-828">
                Swedenmark AI
                <br data-id="element-829" />
                Pompano Beach, FL
                <br data-id="element-830" />
                United States
                <br data-id="element-831" />
                Email:{' '}
                <a href="mailto:hello@swedenmark.ai" className="text-blue-600 hover:underline" data-id="element-832">
                  hello@swedenmark.ai
                </a>
              </address>
            </section>
          </div>
        </div>
      </main>
    </div>;
}